import { Field, Label, Switch } from "@headlessui/react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import FormLabel from "./FormLabel";

const FormToggle = ({
  checked,
  onChange,
  label,
  fieldLabel,
  required,
  hint,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {Boolean(fieldLabel) && (
        <FormLabel required={required} hint={hint}>
          {t(fieldLabel)}
        </FormLabel>
      )}
      <Field
        as="div"
        className={clsx(
          "flex items-center py-2 px-3 border border-gray-300 rounded-md bg-white",
          Boolean(fieldLabel) ? "mt-1" : "",
        )}
      >
        <Switch
          checked={checked}
          onChange={onChange}
          className={clsx(
            checked ? "bg-blue-600" : "bg-gray-200",
            "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
          )}
        >
          <span className="sr-only">Use setting</span>
          <span
            className={clsx(
              checked ? "translate-x-5" : "translate-x-0",
              "pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200",
            )}
          >
            <span
              className={clsx(
                checked
                  ? "opacity-0 ease-out duration-100"
                  : "opacity-100 ease-in duration-200",
                "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity",
              )}
              aria-hidden="true"
            >
              <svg
                className="h-3 w-3 text-gray-400"
                fill="none"
                viewBox="0 0 12 12"
              >
                <path
                  d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span
              className={clsx(
                checked
                  ? "opacity-100 ease-in duration-200"
                  : "opacity-0 ease-out duration-100",
                "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity",
              )}
              aria-hidden="true"
            >
              <svg
                className="h-3 w-3 text-blue-600"
                fill="currentColor"
                viewBox="0 0 12 12"
              >
                <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
              </svg>
            </span>
          </span>
        </Switch>
        {label && (
          <Label as="span" className="ml-3">
            <span className="text-sm text-gray-900">{t(label)}</span>
          </Label>
        )}
      </Field>
    </div>
  );
};

export default FormToggle;
